module.exports = __webpack_public_path__ + "img/loadPoint.5e014530.png";